export default __webpack_public_path__ + "static/media/w.bf61900a.mp4";